import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { isValidNumericInputKey } from '@/helpers';
import { AdjustItem, UserDTO } from '@/models';
import PopupMenu from '@/components/common/popup-menu/PopupMenu.vue';
import UserInformation from '@/components/common/user-information/UserInformation.vue';

@Component({
  components: {
    PopupMenu,
    UserInformation
  }
})
export default class AdjustIndividualDropsForm extends Vue {
  $refs!: {
    popupRef: HTMLFormElement;
    formRef: HTMLFormElement;
  };

  @Prop() adjustItem: AdjustItem;
  @Prop() currentUser: UserDTO;

  private isRemainingDropsFilled = false;
  private rules = {
    adjustedDrops: [
      (v: string) => v !== '' || 'Adjusted pollens is required',
      (v: number) => (v >= 0 && this.checkAdjustedDropsValid(v)) || `Min: 0, Max: ${this.adjustItem.totalReceivedDrops}`
    ],
    reasonForAdjustment: [(v: string) => !!v || 'Please input reason']
  };

  @Watch('isRemainingDropsFilled')
  onFillChecked(): void {
    const { userAdjustIndividualDrops } = this.adjustItem;
    userAdjustIndividualDrops.adjustedDrops =
      (userAdjustIndividualDrops.adjustedDrops > 0
        ? userAdjustIndividualDrops.adjustedDrops
        : userAdjustIndividualDrops.receivedDrops) -
      (this.isRemainingDropsFilled ? this.adjustItem.remainingDrops : -this.adjustItem.remainingDrops);
  }

  onKeyDown(event: KeyboardEvent): void {
    if (!isValidNumericInputKey(event)) {
      event.preventDefault();
    }
  }

  checkAdjustedDropsValid(adjustedDrops: number): boolean {
    return adjustedDrops <= this.adjustItem.totalReceivedDrops;
  }

  openMenu(): void {
    this.$refs.popupRef.openMenu();
  }

  onSave(): void {
    if (this.$refs.formRef.validate()) {
      const { userAdjustIndividualDrops } = this.adjustItem;
      this.$emit('onPopupSave', {
        ...userAdjustIndividualDrops,
        adjustedDrops: parseInt(userAdjustIndividualDrops.adjustedDrops.toString()),
        adjustedBy: this.currentUser.fullName
      });
      this.onCancel();
    }
  }

  onCancel(): void {
    this.resetForm();
    this.$refs.popupRef.closeMenu();
  }

  resetForm(): void {
    this.$refs.formRef.reset();
  }
}
